import {
	BooleanEntityAttribute,
	CustomEntityAttribute,
	DateEntityAttribute,
	Entity, EntityEntityAttribute, EntityListEntityAttribute,
	IntegerEntityAttribute,
	StringEntityAttribute
} from '../base/Entity';

import {Category} from './Category';
import {slugify} from '../util/slugify';
import {VideoCue} from '../../client/src/components/RbVideoPlayer/VideoPlayer';
import {User} from './User';

/**
 * @name VideoQuality
 * @property {String} name
 * @property {Number} size
 *
 */

/**
 *
 * @type {{SD: VideoQuality, HD: VideoQuality, FHD: VideoQuality}}
 */
export const VideoQualities = {
	SD: {
		name: "SD",
		size: 480
	},
	HD: {
		name: "HD",
		size: 720
	},
	FHD: {
		name: "FHD",
		size: 1080
	},
};

/**
 * @name VideoSource
 * @property {String} url
 * @property {VideoQuality} quality
 */
export class VideoSource extends Entity {}

VideoSource.Register();
VideoSource.Attributes = [
	new StringEntityAttribute('url'),
	new CustomEntityAttribute(
		'quality',
		String,
		(o) => o.quality.name,
		(o, v) => o.quality = VideoQualities[v]
	),
];



/**
 * @name VideoCuesRaw
 * @property {Number, VideoCue} opStart
 * @property {Number} opEnd
 * @property {Number} edStart
 * @property {Number} edEnd
 */

/**
 * @name VideoCues
 * @property {VideoCue} opStart
 * @property {VideoCue} opEnd
 * @property {VideoCue} edStart
 * @property {VideoCue} edEnd
 */
export class VideoCues extends Entity {
	constructor() {
		super(...arguments);
	}
}

VideoCues.Register();
VideoCues.Attributes = [
	new CustomEntityAttribute('opStart', Object, (o) => o.opStart.position, (o, v) => {
		if (!o.opStart) o.opStart = new VideoCue('Abertura', 0);
		o.opStart.position = v
	}),
	new CustomEntityAttribute('opEnd', Object, (o) => o.opStart.position, (o, v) => {
		if (!o.opEnd) o.opEnd = new VideoCue('Pular Abertura', 0);
		o.opEnd.position = v
	}),
	new CustomEntityAttribute('edStart', Object, (o) => o.opStart.position, (o, v) => {
		if (!o.edStart) o.edStart = new VideoCue('Encerramento', 0);
		o.edStart.position = v
	}),
	new CustomEntityAttribute('edEnd', Object, (o) => o.opStart.position, (o, v) => {
		if (!o.edEnd) o.edEnd = new VideoCue('/Encerramento', 0);
		o.edEnd.position = v
	}),
];



/**
 * @name VideoData
 * @property {String} fileName
 * @property {String} baseUrl
 * @property {VideoCues} cues
 */
export class VideoData extends Entity {}

VideoData.Register();
VideoData.Attributes = [
	new StringEntityAttribute('fileName'),
	new StringEntityAttribute('baseUrl'),
	new EntityEntityAttribute('cues', VideoCues).default(() => ({}))
];


/**
 * @name VideoComment
 *
 * @property {Number} Id
 * @property {Number} VideoId
 * @property {Number} UserId
 * @property {Number} ParentId
 * @property {String} Text
 * @property {Date} Timestamp
 * @property {Boolean} IsSpoiler
 * @property {Boolean} Deleted
 * @property {User} User
 * @property {VideoComment[]} Comments
 */
export class VideoComment extends Entity {}

VideoComment.Register();
VideoComment.Attributes = [
	new IntegerEntityAttribute('Id'),
	new IntegerEntityAttribute('VideoId'),
	new IntegerEntityAttribute('UserId'),
	new IntegerEntityAttribute('ParentId'),
	new StringEntityAttribute('Text'),
	new DateEntityAttribute('Timestamp', true),
	new BooleanEntityAttribute('IsSpoiler'),
	new BooleanEntityAttribute('Deleted'),
	new EntityEntityAttribute('User', User),
	new EntityListEntityAttribute('Comments', VideoComment),
];




/**
 * @name Video
 * @property {Number} Id
 * @property {Number} CategoryId
 * @property {Category} Category
 *
 * @property {String} Name
 * @property {Date} Date
 * @property {String} Description
 * @property {Number} Order
 * @property {Number} Views
 *
 * @property {String} Thumbnail
 * @property {String} Subtitle
 * @property {Boolean} Hidden
 * @property {Boolean} SponsorOnly
 * @property {Date} PublicAvailability
 *
 * @property {VideoSource[]} Sources
 * @property {VideoSource[]} Mirrors
 *
 * @property {VideoComment[]} Comments
 *
 * @property {VideoData} Data
 */
export class Video extends Entity {
	constructor() {
		super(...arguments);

		// if (this.Sources) this.Sources.forEach(s => {
		// 	s.url = this.getUrl(s);
		// });
	}

	getSmallThumbnail() {
		return `https://old.rwbybrasil.com/dynamic/videos/${this.Id}th.jpg?`;
	}

	getRoute() {
		return {
			name: 'video',
			params: {
				id: this.Id,
				name: slugify(this.Name.toLowerCase())
			}
		}
	}

	getPubliclyAvailableTime() {
		return Math.max(this.PublicAvailability.getTime(), this.Date.getTime());
	}

	getUrl(source) {
		return `https://old.rwbybrasil.com/do/Video.GetFile?id=${this.Id}&q=${this.Sources.indexOf(source)}`;
	}
}

Video.Register('Video');
Video.Attributes = [
	new IntegerEntityAttribute('Id'),
	new IntegerEntityAttribute('CategoryId'),
	new EntityEntityAttribute('Category', Category),
	new IntegerEntityAttribute('Order'),
	new StringEntityAttribute('Name'),
	new DateEntityAttribute('Date', true),
	new StringEntityAttribute('Description'),
	new EntityListEntityAttribute('Sources', VideoSource, true),
	new EntityListEntityAttribute('Mirrors', VideoSource, true),
	new EntityListEntityAttribute('Comments', VideoComment),
	new StringEntityAttribute('Thumbnail'),
	new StringEntityAttribute('Subtitle'),
	new BooleanEntityAttribute('Hidden'),
	new IntegerEntityAttribute('Views'),
	new EntityEntityAttribute('Data', VideoData, true),
	new BooleanEntityAttribute('SponsorOnly'),
	new DateEntityAttribute('PublicAvailability', true)
];

export default Video;
